module.exports = __webpack_public_path__ + "static/cloudes-ab3b5d15a4039d4bb6ad2db387d93c1e.png";